import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all workOrderStatuses
export const getWorkOrderStatus = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-status`);
    return response.data;
  } catch (error) {
    console.error("Error fetching workOrderStatuses:", error.response?.data || error);
    throw error;
  }
};

// GET a single workOrderStatus
export const getWorkOrderStatusById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/work-order-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching workOrderStatus:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new workOrderStatus
export const createWorkOrderStatus = async (workOrderStatusData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/work-order-status`, workOrderStatusData);
    return response.data;
  } catch (error) {
    console.error("Error creating workOrderStatus:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing workOrderStatus
export const updateWorkOrderStatus = async (id, workOrderStatusData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/work-order-status/${id}`, workOrderStatusData);
    return response.data;
  } catch (error) {
    console.error("Error updating workOrderStatus:", error.response?.data || error);
    throw error;
  }
};

// DELETE a workOrderStatus
export const deleteWorkOrderStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/work-order-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting workOrderStatus:", error.response?.data || error);
    throw error;
  }
};
